// extracted by mini-css-extract-plugin
module.exports = {"icon__container":"styles_icon__container__73PM2","icon__bg--circle":"styles_icon__bg--circle__Pn8hM"};